export default __webpack_public_path__ + "static/media/pad_layout.cdb7d52a.jpg";